<div class="d-flex align-items-center input-field-with-autocomplete-option">
  <div class="d-flex align-items-center g-2">
    @for (icon of option.icons; track icon) {
      <div
        data-id="autocomplete-option-icon"
        class="d-flex align-items-center justify-content-center input-field-with-autocomplete-option-icon"
      >
        <img
          height="16px"
          width="16px"
          loading="lazy"
          src="assets/icons/{{ icon }}.svg"
          alt="icon"
        />
      </div>
    }
    <p data-id="autocomplete-option-title" class="input-field-with-autocomplete-option-title">
      {{ option.title }}
    </p>
  </div>
  <p data-id="autocomplete-option-suffix" class="input-field-with-autocomplete-option-suffix">
    {{ option.suffix }}
  </p>
</div>
